<!--
 * @Description: 发版管理
 * @Author: yangxr
 * @Date: 20222-08-08 11:18:28
 * @LastEditors: yangxr
 * @LastEditTime: 20222-08-08 11:18:28
-->
<template>
	<div class="pages_content ProcessManagement table">
		<el-container>
			<el-header>
				<breaDcrumb />
			</el-header>
			<el-main style="display: flex">
				<div class="main_left scroll">
					<treeContainer :arr="systemList" @chooseTree="setTree" />
				</div>
				<div class="main_right card_bg">
					<div class="header_right" @click="showCardNav = !showCardNav">
						<div class="title">搜索</div>
						<div>
							<transition name="from"></transition>
							<span v-show="!showCardNav"><i style="margin-right: 5px;" class="el-icon-arrow-down"></i></span>
							<transition name="to"></transition>
							<span v-show="showCardNav"><i style="margin-right: 5px;" class="el-icon-arrow-up"></i></span>
						</div>
					</div>
					<div v-show="showCardNav" class="hr"></div>
					<el-collapse-transition>
						<div v-show="showCardNav" class="search">
							<span>
								<span style="margin-right: 12px;">版本</span>
								<el-input v-model="tableParam.code" style="width: 20%;max-width: 200px;" clearable placeholder="请输入"  @keyup.enter.native="initData()"/>
							</span>
							<el-button icon="el-icon-search" size="medium" class="bottom_all" @click="initData()">查 询</el-button>
							<el-button size="medium" class="bottom_all_two" @click="reset()">重 置</el-button>
						</div>
					</el-collapse-transition>
					<div class="hr"></div>
					<div class="card scroll">
						<div class="card_nav">
							<div>
								<el-button size="small" class="bottom_all" style="margin-left: 0;" @click="add()">
									<i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
									发布新版本
								</el-button>
							</div>
						</div>
						<!-- 列表 -->
						<div class="card_info" :style="style">
							<el-table ref="multipleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark">
								<el-table-column align="center" type="selection" width="50"></el-table-column>
								<template v-for="(item, index) in table">
									<el-table-column v-if="item.status" :key="index" :label="item.label" align="center" :width="item.width">
										<template slot-scope="scope">
                                            <div v-if="item.label == '发版端'">
                                                <span v-if="scope.row.publishingClientType == 1">PC端</span>
                                                <span v-if="scope.row.publishingClientType == 2">小程序端</span>
                                                <span v-if="scope.row.publishingClientType == 3">Android端</span>
                                                <span v-if="scope.row.publishingClientType == 4">IOS端</span>
                                            </div>
											<span v-else>{{ scope.row[item.prop] }}</span>
										</template>
									</el-table-column>
								</template>
							</el-table>
						</div>
					</div>
				</div>
			</el-main>
			<div class="card_bottom">
				<div class="card_bottom_left">
					<div class="top_page_totle">总共{{ total }}条</div>
					<el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="initData()"></el-pagination>
				</div>
				<div>
					<el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="initData()">刷新</el-button>
				</div>
			</div>
		</el-container>
		<!-- 添加 -->
		<el-dialog v-dialogDrag :visible.sync="dialogVisible" width="40%">
			<span slot="title" class="dialog-title">{{ dialogtitle }}</span>
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="发版系统" prop="systemId">
					<el-select v-model="form.systemId" disabled placeholder="请选择" style="width:100%;">
						<el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="发版端" prop="publishingClientType">
					<el-select v-model="form.publishingClientType" placeholder="请选择" style="width:100%;">
						<el-option  key="1" label="PC端" :value="1"></el-option>
						<el-option  key="2" label="小程序端" :value="2"></el-option>
						<el-option  key="3" label="Android端" :value="3"></el-option>
						<el-option  key="4" label="IOS端" :value="4"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="版本号" prop="code">
					<el-input v-model="form.code" placeholder="请输入版本号" clearable />
				</el-form-item>
				<el-form-item label="更新日志">
					<el-input v-model="form.publishingClientLog" placeholder="请填写更新日志" class="textarea" type="textarea" resize="none" rows="5"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button class="bottom_all_two" @click="dialogVisible = false">取 消</el-button>
				<el-button class="bottom_all" type="primary" @click="save('form')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import breaDcrumb from '@/components/breadcrumb';
import treeContainer from '@/components/GlobalTree/tree';
import { mapGetters } from 'vuex';
import { queryPage } from '@/api/basedata/business';
import { saveOrUpdate, getVersionList } from '@/api/basedata/versionMan';

export default {
	components: {
		breaDcrumb,
		treeContainer
	},
	data() {
		return {
			/*添加修改弹窗*/
			dialogVisible: false,
			loading: false,
			dialogtitle: '',
			/*弹要修改过着添加的数据*/
			form: {
				code: '',
				systemId: '',
				systemName: '',
				publishingClientType: '',
				publishingClientLog: '',
			},
			/*判断收起展开*/
			showCardNav: true,
			table: [
				{ label: '发版端', width: 'auto', prop: 'publishingClientType', status: true },
				{ label: '版本号', width: 'auto', prop: 'code', status: true },
				{ label: '发布时间', width: 'auto', prop: 'createTime', status: true },
				{ label: '更新日志', width: 'auto', prop: 'publishingClientLog', status: true },
			],
			/*列表选中的数据集*/
			tableParam: {
				page: 1,
				pageSize: 10,
				systemId:"",
			},
			total: 0,
			tableData: [],
			systemList: [],
			rules: {
				code: [
					{ required: true, message: '请输入编码', trigger: 'blur' },
				],
				systemId: [
					{ required: true, message: '请选择系统', trigger: 'change' }
				],
				name: [
					{ required: true, message: '请输入名称', trigger: 'blur' },
				],
				processType: [
					{ required: true, message: '请选择类别', trigger: 'change' }
				],
				codeRulesId: [
					{ required: true, message: '请选择编码规则', trigger: 'change' }
				]
			},
			checkNode: '',
		};
	},
	mounted() {
		this.initSystemList();
	},
	methods: {
		/*重置*/
		reset() {
			this.tableParam.code = '';
			this.initData();
		},
		/*接受树状数据*/
		setTree(e) {
            console.log(e)
			this.checkNode = e;
            this.tableParam.systemId = e.id
            this.initData();
		},
		/*添加*/
		add() {
			if (!this.checkNode) {
				this.$message({
					message: '请先选择系统后添加！！！',
					type: 'warning'
				});
				return
			}
			const systemId = this.checkNode.parentId === 0 ? this.checkNode.id : this.checkNode.systemName;
			this.form = {
				code: '',
				systemId: systemId,
				systemName: '',
				publishingClientType: '',
				publishingClientLog: '',
			}
			this.dialogVisible = true;
			this.dialogtitle = '发布新版本';
		},
		/*获取列表*/
		initData() {
			this.loading = true;
			getVersionList(this.tableParam).then(res => {
				if (res.code === 1001) {
					this.tableData = res.data.data;
					this.total = res.data.totalRows;
				}
			});
		},
		initSystemList() {
			queryPage({ page: 1, pageSize: 1000 }).then(res => {
				if (res.code === 1001) {
					this.systemList = res.data.data.map((item) => (
						{ ...item, parentId: 0 }
					));
					this.initData()
				}
			});
		},
		save(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					for (let i in this.systemList) {
						if (this.systemList[i].id === this.form.systemId) {
							this.form.systemName = this.systemList[i].name;
							break;
						}
					}
					this.form.parentId = this.form.parentId ? this.form.parentId : 'parent_id';
					if (this.form.processType === 1) {
						this.form.formType = ''
					}
					saveOrUpdate(this.form).then(res => {
						if (res.code === 1001) {
							this.$message({
								message: '操作成功',
								type: 'success',
							});
							this.dialogVisible = false;
							this.initData();
						}
					})
				}
			});
		},
		sizeChange(value) {
			this.tableParam.pageSize = value;
			this.initData();
		},
	},
	computed: {
		...mapGetters({
			screenWidth: 'getscreenWidth',
			screenHeight: 'getscreenHeight',
			Collapse: 'getsCollapse'
		}),
		style() {
			let num = 0;
			if (this.Collapse) {
				num = this.screenWidth - 324;
			} else {
				num = this.screenWidth - 421;
			}
			return 'width:' + num + 'px;';
		}
	}
};
</script>
<style lang="scss" scoped>
.ProcessManagement {
  .el-link {
    i {
      color: $bg_color;
    }
  }
  .el-link:hover {
    color: $bg_color;
  }
  .dialoginfo {
    width: 560px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      > span {
        display: flex;
        align-items: center;
      }
    }
    .textarea_input {
      padding-top: 10px;
      align-items: flex-start;
      height: auto;
    }
  }
  font-size: $font_size;
}
</style>
